import api from '../../../api'
import livevoxService from '../../../api/clients/livevoxService'
import * as types from './mutation-types'
import * as globalTypes from '../../mutation-types'
import router from '../../../router'
import StorageManager from '../../../utils/storageManager'
import config from '../../../config'
import verintState from '../../../utils/verintState'

export const login = ({ commit, rootGetters, dispatch}, payload) => {
  commit(types.LOGIN)
  commit(globalTypes.LOADING_START, 'Validating credentials...');
  console.log('***LOGIN****')
  // show spinner
  api.authLogin(payload.creds)
    .then(response => {

      //do some stuff 
      if (response.status != 200) {
        const error = {
          title: 'Error',
          message: response.data,
          type: 'error'
        }
        commit(globalTypes.NOTIFY_ERRORS, error)
      }
      else {
        StorageManager.saveJWT("CarBuyServiceJWT", response.data.jwt);
        const user = response.data.user;

        if (!user.enabled) {
          commit(types.LOGIN_DISABLED, userinfo)
          commit(globalTypes.LOADED_SUCCESS)
          return;
        }

        let userinfo = {
          userID: user.userID,
          userName: user.userName,
          permissions: user.permissions
        }
        // Search for InActive Role Set Prior to Completion
        for (let i = 0; i < user.permissions.length; i++) {
          if (user.permissions[i] == 8) {
            commit(types.LOGIN_DISABLED, userinfo)
            commit(globalTypes.LOADED_SUCCESS)
            return;
          }
        }

        commit(types.LOGIN_SUCCESS, userinfo)

        // Verint right after CarBuy JWT is stored.
        // This avoids relying on a later request to trigger token acquisition.
        if(config.use_verint === "true"){
          verintState.loginAttempted = true;
          dispatch('verintLogin').catch(() => {});
        } 
      
        // if UseLiveVox is param in route path, push to router accordingly else use config settings
        if(payload.UseLiveVox){
            // sets values on intial load
          commit(globalTypes.SET_LIVEVOX, "true");

          // these values will be used on page refresh
          localStorage.setItem('useLiveVox', "true");
          router.push('/livevoxlogin')
          return;
        }

        // if UseMitel is param in route path, push to router accordingly else use config settings
        if(payload.UseMitel){
          // sets values on intial load
          commit(globalTypes.SET_MITEL, "true");

          // these values will be used on page refresh
          localStorage.setItem('useMitel', "true");
          router.push('/mitellogin')
          return;
        }
        
        if (config.use_mitel === "true") {
          router.push('/mitellogin')
          return;
        }
        
        if (config.use_livevox === "true") {
          router.push('/livevoxlogin')
          return;
        }

        commit(globalTypes.MITEL_LOGIN_SKIP)
        if (rootGetters.lastNavigation !== '') {
          router.push(rootGetters.lastNavigation)
        }
        else {
          router.push('/')
        }
      }
      commit(globalTypes.LOADED_SUCCESS)
    })
    .catch(err => {
      console.log(err)
      const error = {
        title: 'Error',
        message: err.message,
        type: 'error'
      }
      commit(globalTypes.NOTIFY_ERRORS, error)
      commit(globalTypes.LOADED_SUCCESS)
    });

  return;
}
export const logout = ({ commit }) => {
  StorageManager.removeJWT("CarBuyServiceJWT");

  // if useMitel exists, clear value out
  var useMitelLocal = localStorage.getItem('useMitel');
  if(useMitelLocal){
    localStorage.removeItem('useMitel');
  }

  // if useLiveVox exists, clear value out
  var useLiveVoxLocal = localStorage.getItem('useLiveVox');
  if(useLiveVoxLocal){
    localStorage.removeItem('useLiveVox');
  }


  // if mitelToken exist, clear the token out
  var mitelToken = StorageManager.getJWT("MitelServiceJWT");
  if(mitelToken){
    StorageManager.removeJWT("MitelServiceJWT");
  }

  // if livevoxToken exist, clear the token out
  var livevoxToken = StorageManager.getJWT("LivevoxServiceJWT");
  if(livevoxToken){
    StorageManager.removeJWT("LivevoxServiceJWT");
  }


  commit(globalTypes.SET_LAST_NAVIGATION, '');
  verintState.loginAttempted = false;
  commit(types.LOGOUT)
  router.push('/login')
}

export const livevoxPopUpData = async ({ commit, rootGetters }, creds) => {
  commit(globalTypes.LOADING_START, 'Validating credentials...');
  console.log('***LOGIN****')
  // show spinner
  await livevoxService.fetchPopUpData();

  commit(globalTypes.LOADED_SUCCESS)
}


// WEBPACK FOOTER //
// ./src/store/modules/login/actions.js